import React from "react";
import { useNavigate } from "react-router-dom";

const MultiCountBoxCard = (props) => {
  const navigate = useNavigate();
  const { navigateLink = "", label, totalCount = 0, directCount = 0, cpCount = 0 } = props;

  return (
    <div className="card">
      <div className="card-body">
        <div className="chart-widget-dashboard">
          <div className="media">
            <a
              className="media-body"
              style={{ cursor: "pointer" }}
              onClick={() => (navigateLink ? navigate(navigateLink) : {})}
            >
              <h5 className="mt-0 mb-0 f-w-600 text-center">
                <i data-feather="dollar-sign" />
                <span className="counter text-center">{label}</span>
              </h5>

              {/* Flex container for aligning counts */}
              <div style={{
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center", 
                gap: "60px", // Creates space between the left and right content
              }}>
                {/* Breakdown on the left */}
                <div style={{
                  fontSize: "14px", 
                  color: "#6c757d", 
                  textAlign: "center"
                }}>
                    <div>CP: {cpCount}</div>
                  <div>Direct: {directCount}</div>
                  
                </div>

                {/* Total count on the right */}
                <h5 className="dashboard-count" style={{
                  fontSize: "24px", 
                  fontWeight: "600", 
                  textAlign: "center"
                }}>
                  {totalCount > 0 ? totalCount : "00"}
                </h5>
              </div>

            </a>
            <i data-feather="tag" />
          </div>
          <div className="dashboard-chart-container">
            <div className="small-chart-gradient-1" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultiCountBoxCard;
